import Badge from './Badge';

export default {
  id: 'radial_7',
  title: 'Radial_7',
  colors: 3,
  animated: true,
  premium: true,
  BadgeComponentStateless: Badge
};
